import React, { lazy } from "react";
import { Formik, Field, Form } from "formik"
import l from "components/util/l";
import { MultiField } from "seed/helpers";
import { UpgradePlanMessage } from "components/util/helpers/PlanMessages";
import Templates from "components/vmisc/templates/Templates";


const FlowCreateFormView = ({
  isDeveloper,
  selectedTemplateFlow,
  onSelectFlowTemplate,
  onClickDevButton,
  onSubmit
}) => (
  <div className="card w-100 h-100">

    <div class="card-header">
      <h3 class="card-header-title">
        {l("Crear solución%SB033")}
      </h3>
    </div>

    <div className="card-body">
      <Templates onSelectFlowTemplate={onSelectFlowTemplate} />
    </div>

    <div className="card-footer">
      <div className="d-flex justify-content-end align-items-center">
        {isDeveloper && <div className="btn btn-outline-primary mr-2" onClick={onClickDevButton}>Crear flow (dev)</div>}
        <button className="btn btn-primary" onClick={onSubmit} disabled={!selectedTemplateFlow}>
          {l("Crear solución%SB033")}
        </button>
      </div>
    </div>
  </div>
);

export default FlowCreateFormView;